import React, { useRef, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Person as PersonIcon,
  CalendarToday as CalendarTodayIcon,
  CheckCircle as CheckCircleIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { obtenerTareaPorId } from '../../actions/TareasAction.js';

export default function TTareas(props) {
  const mounted = useRef(true);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const rows = props.rows;
  const term = props.termc;
  const history = useHistory();

  const abrirPerfilTarea = (tarea) => {
    if (props.factura) {
      obtenerTareaPorId(tarea.tareA_Id).then((response) => {
        if (response.status === 200) {
          tarea['TipoVisitante'] = props.id;
          tarea['facturas'] = response.data[0].facturas;
          history.push({ pathname: '/perfilTarea', state: tarea });
        }
      });
    } else {
      tarea['TipoVisitante'] = props.id;
      if (props.cobrador) {
        tarea['perfilCobrador'] = true;
      }
      history.push({ pathname: '/perfilTarea', state: tarea });
    }
  };

  function searchingTermc(term) {
    return function (x) {
      let nombre = '';
      let apellido = '';
      let descritipotarea = '';
      let fechacreacion = '';
      let fechavto = '';
      let codtarea = 0;

      if (props.factura) {
        nombre = x.cliente || '';
        apellido = x.cliente || '';
        descritipotarea = x.descritipotarea || '';
        fechacreacion = x.fechacreacion || '';
        fechavto = x.fechavto || '';
        codtarea = x.codtarea || 0;
      } else {
        if (x.cliente !== null) {
          nombre = x.cliente.nombre || '';
          apellido = x.cliente.apellido || '';
        } else {
          nombre = x.posiblecliente?.nombre || '';
          apellido = x.posiblecliente?.apellido || '';
        }
        descritipotarea = x.tipotarea?.descritipotarea || '';
        fechacreacion = x.fechacreacion || '';
        fechavto = x.fechavto || '';
        codtarea = x.codtarea || 0;
      }

      return (
        nombre.toLowerCase().includes(term.toLowerCase()) ||
        apellido.toLowerCase().includes(term.toLowerCase()) ||
        descritipotarea.toLowerCase().includes(term.toLowerCase()) ||
        fechacreacion.toLowerCase().includes(term.toLowerCase()) ||
        fechavto.toLowerCase().includes(term.toLowerCase()) ||
        codtarea.toString().toLowerCase().includes(term.toLowerCase()) ||
        !term
      );
    };
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const filteredRows = (rows || []).filter(searchingTermc(term));
  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    return function cleanup() {
      mounted.current = false;
    };
  }, [rows]);

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Tipo de Tarea
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Cliente
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Fec.Creación
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Fec.Vto
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Usuario Asignado
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Asignado Por
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Estado
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((tarea) => {
                const isCompletado = tarea.motivocancelacion !== null;
                const tipoTarea = props.factura
                  ? tarea.tipotarea
                  : tarea.tipotarea?.descritipotarea || '—';
                const cliente = props.factura
                  ? tarea.cliente
                  : tarea.cliente !== null
                  ? `${tarea.cliente.nombre} ${tarea.cliente.apellido}`
                  : `${tarea.posiblecliente?.nombre || ''} ${
                      tarea.posiblecliente?.apellido || ''
                    }`.trim();

                return (
                  <TableRow
                    key={tarea.tareA_Id}
                    hover
                    sx={{
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      '&:nth-of-type(even)': {
                        backgroundColor: 'action.hover',
                      },
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <AssignmentIcon
                          sx={{ fontSize: 20, color: 'primary.main' }}
                        />
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {tipoTarea}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <PersonIcon sx={{ fontSize: 20, color: 'action.active' }} />
                        <Typography variant="body2">{cliente}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CalendarTodayIcon
                          sx={{ fontSize: 18, color: 'action.active' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ fontFamily: 'monospace' }}
                        >
                          {tarea.fechacreacion?.substr(-20, 10) || '—'}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CalendarTodayIcon
                          sx={{ fontSize: 18, color: 'action.active' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ fontFamily: 'monospace' }}
                        >
                          {tarea.fechavto?.substr(-20, 10) || '—'}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {tarea.usuarioasignado || '—'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {tarea.asignadopor || '—'}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        icon={
                          isCompletado ? (
                            <CheckCircleIcon />
                          ) : (
                            <HourglassEmptyIcon />
                          )
                        }
                        label={isCompletado ? 'COMPLETADO' : 'PENDIENTE'}
                        size="small"
                        color={isCompletado ? 'success' : 'warning'}
                        sx={{ fontWeight: 600 }}
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<VisibilityIcon />}
                        onClick={() => abrirPerfilTarea(tarea)}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          px: 1.5,
                          borderRadius: 1.5,
                          boxShadow: 1,
                          '&:hover': {
                            boxShadow: 3,
                            transform: 'translateY(-1px)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        Ver Perfil
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 2,
                      color: 'text.secondary',
                    }}
                  >
                    <AssignmentIcon sx={{ fontSize: 64, opacity: 0.3 }} />
                    <Typography variant="h6">
                      No se encontraron tareas
                    </Typography>
                    <Typography variant="body2">
                      {term
                        ? 'Intenta con otros términos de búsqueda'
                        : 'Aún no hay tareas registradas'}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            fontWeight: 500,
          },
        }}
      />
    </Box>
  );
}
